const guest = ({next, store}) => store.getters['auth/currentUser'].userId ? next({name: 'index'}) : next();

export default guest;